<template>
  <zt-modal
    class="rounded font-normal"
    :title="$t('message.main_bussines_page.workflow.modals.disabled.title')"
    @close="closeDialog" max-width="600px"
    :active="active"
    :z-index="1001"
  >
    <template>
      <div class="flex px-10 py-12">
        <div class="flex flex-none items-center w-24 h-24 justify-center mr-16">
          <zt-icon
            name="exclamation-circle-outline"
            class="text-zt-warning"
            :style="{ fontSize: '6rem'}"
          />
        </div>
        <div v-if="!errorText">
          <p class="text-zt-xl mb-4 text-zt-dark-500">
            <span>
              {{
                $t('message.main_bussines_page.workflow.modals.disabled.body_title')
              }}
            </span>
          </p>
          <p class="text-custom-legend text-zt-dark-400 mb-8">
            {{
              $t('message.main_bussines_page.workflow.modals.disabled.body')
            }}
          </p>
          <zt-input
            v-if="false"
            v-model="userPassword"
            label="Password"
            outlined
            type="password"
            data-vs-input="password-confirm"
          />
        </div>

        <div v-if="errorText" class="mt-2 text-zt-base text-zt-danger">
          <p class="text-zt-xl mb-4 text-zt-dark-500">
            <span>{{ errorText }}</span>
          </p>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div
        class="zt-modal-footer rounded-b flex justify-end items-center p-4"
      >
        <zt-button
          text
          color="dark-300"
          class="button-cancel mr-4"
          @click="closeDialog"
          data-vs-button="closeDialog"
        >
          {{
            $t('message.main_bussines_page.workflow.modals.disabled.cancel')
          }}
        </zt-button>
        <zt-button
          class="w-25"
          color="danger"
          :loader="isLoading"
          @click="cancelWorkflow"
          data-vs-button="confirm"
        >
          {{
            $t('message.main_bussines_page.workflow.modals.disabled.action')
          }}
        </zt-button>
      </div>
    </template>
  </zt-modal>
</template>
<script>
import Workflow from "@/apiClient/Workflow";

export default {
  name: 'ModalDisableWorkflow',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    },
    fnDisabled: {
      type: Function,
      default: () => {}
    }
  },
  watch: {
    active() {
      this.isLoading = false
      this.userPassword = ''
      this.errorText = ''
    }
  },
  data() {
    return {
      errorText: '',
      userPassword: '',
      workflowInstance: new Workflow(),
      isLoading: false
    }
  },
  methods: {
    async cancelWorkflow() {
      try {
        this.isLoading = true
        await this.workflowInstance.disableWorkflow(this.item.id)
        this.userPassword = ''
        this.isLoading = false
        this.fnDisabled(this.item.id)
        this.closeDialog()
      } catch (e) {
        this.errorText = 'El workflow no pudo ser desactivado'
        this.isLoading = false
      }
    },
    closeDialog() {
      if (this.isLoading) return
      this.$emit('close-disable-modal', this.item.id)
    }
  }
}
</script>

<style scoped lang="scss">
.zt-modal-footer {
  background-color: #EEEEEE;
}
.text-custom-legend {
  font-size: 1.125rem;
}
::v-deep {
  .zt-modal {
    box-shadow: 0 3px 4px rgba(0, 0, 0, 0.14), 0 3px 3px rgba(0, 0, 0, 0.12),
    0 1px 8px rgba(0, 0, 0, 0.2);
  }
  .zt-modal.rounded {
    border-radius: .375rem!important;
  }
  button.button-cancel {
    color: #707070!important;
    background-color: transparent!important;
  }
}
</style>
